import './Pagination.css';
import React, {useEffect, useState} from 'react';
import PageLimit from './pageLimit/PageLimit';
import PageList from './pageList/PageList';

const Pagination = (props) => {

  return (
      <div id={'pagination'}>
        {
          props.countPages > 1 && props.countPages > props.page ?
              <div className="show-more"
                   onClick={props.onShowMore}>
                <i className="icon-showing-more"></i>
                <span>{props.messages.NAV_SHOW_MORE}</span>
              </div> :
              <></>
        }
        <PageList page={props.page}
                  lastPage={props.lastPage}
                  firstPage={props.firstPage}
                  savePage={props.savePage}
                  countPages={props.countPages}
                  onChange={props.onPageChange}/>
      </div>
  );
};

export default Pagination;